<script setup>
import { ref, onMounted, onUnmounted, watch, onBeforeMount, computed } from "vue";
import LocalStorage from '@/controller/LocalStorage.js';
import { useI18n } from 'vue-i18n';
import CustomInput from '@/components/common/utils/CustomInput.vue';
import { endOfMonth, endOfYear, startOfMonth, startOfYear, subMonths } from 'date-fns';


const {t} = useI18n;
const cruz = "/assets/home/cruz.svg";
const props = defineProps({
  activeFilters: String,
  brand: String,
  status: String,
  headers: Array,
  src: String,
  name: String,
  filters: Object,
});
const emit = defineEmits(["activeItem", "filterChanged"]);

const filterType = computed(() => props.headers.map(header => header.filter.type));
const filterTypeValue = computed(() => {
  if(filterType.value.includes('date')){
    return 'date';
  }else if(filterType.value.includes('dateNoType')){
    return 'nextVisit';
  }
  return 'nextVisit';
})

//calendar filter
const date = ref();
const dateBorderColor = ref('#CBD5E1');
const presetDates = ref([
  { label: 'Hoy', value: [new Date(), new Date()] },
  { label: 'Este mes', value: [startOfMonth(new Date()), endOfMonth(new Date())] },
  {
    label: 'Último mes',
    value: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
  },
  { label: 'Este año', value: [startOfYear(new Date()), endOfYear(new Date())] },
]);

function handleDateChangeClosed() {
    if (!date.value || !date.value[0] || !date.value[1]) {
          return;
    }
    const start = new Date(date.value[0]);
    const end = new Date(date.value[1]);

    const formattedStartDate = `${start.getDate().toString().padStart(2, '0')}/${(start.getMonth() + 1).toString().padStart(2, '0')}/${start.getFullYear()}`;
    const formattedEndDate = `${end.getDate().toString().padStart(2, '0')}/${(end.getMonth() + 1).toString().padStart(2, '0')}/${end.getFullYear()}`;

    dateBorderColor.value = userColor.value;
    
    const dateFilter = {
        type: filterTypeValue.value,
        dateRange: `${formattedStartDate} - ${formattedEndDate}`
    };

    const existingIndex = activeFiltersArray.value.findIndex(filter => filter.includes(" - "));
    if (existingIndex !== -1) {
        activeFiltersArray.value.splice(existingIndex, 1);
    }


    activeFiltersArray.value.push(dateFilter.dateRange);
    emit("filterChanged", filterTypeValue.value, { startDate: Date.parse(start) / 1000, endDate: Date.parse(end) / 1000 });
    return dateFilter;
}


function handleClear(index) {
    const filter = activeFiltersArray.value[index];
    if (filter.type === 'brand' || filter.type === 'image') {
      activeFiltersArray.value.splice(index, 1);
      emit("filterChanged", "brand", "");
    } else {
      dateBorderColor.value = '#CBD5E1';
      activeFiltersArray.value.splice(index, 1);
      date.value = null;
      emit("filterChanged", filterTypeValue.value, { startDate: null, endDate: null });
    }
}

function clearInputText(index) {
    //workaround for brand/imgae column at vehicles
    activeFiltersArray.value.splice(index, 1);
    emit("filterChanged", "brand" || "image", "");
}
function dateformat(date) {
    let startdate = date[0];
    let enddate = date[1];
    let startdateDay = startdate.getDate().toString().padStart(2, '0');
    let startdateMonth = (startdate.getMonth() + 1).toString().padStart(2, '0');
    let startdateYear = startdate.getFullYear().toString().slice(-2);
    let enddateDay = enddate.getDate().toString().padStart(2, '0');
    let enddateMonth = (enddate.getMonth() + 1).toString().padStart(2, '0');
    let enddateYear = enddate.getFullYear().toString().slice(-2);
    return `${startdateDay}/${startdateMonth}/${startdateYear} - ${enddateDay}/${enddateMonth}/${enddateYear}`;
}
const updateMonth = (event, updateMonthYear, year) => {
  updateMonthYear(+(event.target).value, year);
};
const updateYear = (event, updateMonthYear, month) => {
  updateMonthYear(month, +(event.target).value);
};
const addMonth = (event, updateMonthYear, month, year) => {
    if(month == 11){
        updateMonthYear(0, year+1);
    }else{
        updateMonthYear(month+1, year);
    }
};
const minusMonth = (event, updateMonthYear, month, year) => {
    if(month == 0){
        updateMonthYear(11, year-1);
    }else{
        updateMonthYear(month-1, year);
    }
};

function handleInternal(date){
    if(date && date.length){
        date = date.map(element => {
            element.setHours(0, 0, 0, 0);
            return element;
        });
    }
}
//calendar filter
onBeforeMount(() => {
   if(props.name == 'date' && filterValue.value.value){
        let start = new Date(filterValue.value.value.startDate * 1000);
        let end = new Date((filterValue.value.value.endDate * 1000)-3600000);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 0, 0);
        start = start.toISOString();
        end = end.toISOString();
        date.value = [start, end];
    }
});

const brandValue = ref(props.brand);
const statusValue = ref(props.status);
const activeFilters = ref(props.activeFilters);

const isMobileView = ref(()=> window.innerWidth <= 576);
const isDesktopView = ref(()=> window.innerWidth > 576)
const updateView = () => {
  isMobileView.value = window.innerWidth <= 576;
  isDesktopView.value = window.innerWidth > 576;
};

const userColor = ref(LocalStorage.getColor());
const userTertiaryColor = ref(LocalStorage.getColorTertiary());
const selectedColor = ref(LocalStorage.getColorSelected());
const selectedColorHover = ref(LocalStorage.getColorSelectedHover());
const configIcon = '/assets/home/ajustes.svg';
const isFilterOpen = ref(false);
const toggleFilters = () => {
    document.body.classList.add('no-scroll');
    isFilterOpen.value = !isFilterOpen.value;
}

const closeFilters = () => {
    document.body.classList.remove('no-scroll');
    isFilterOpen.value = false;
}


onMounted(() => {
  window.addEventListener('click', closeFiltersOnClickOutside);
  window.addEventListener('resize', updateView);

  if (props.filters.status && props.filters.status.length > 0) {
    const statusHeader = props.headers.find(header => header.name === 'status');
    if (statusHeader && statusHeader.filter && statusHeader.filter.data) {
      const matchingData = statusHeader.filter.data.find(item => item.id === props.filters.status);
      if (matchingData) {
        activeFiltersArray.value.push(matchingData);
      }
    }
  }
  
});

onUnmounted(() => {
  window.removeEventListener('click', closeFiltersOnClickOutside);
  window.removeEventListener('resize', updateView);
});

const closeFiltersOnClickOutside = (event) =>{
  if (isFilterOpen.value && !event.target.closest('.filters') && !event.target.closest('.delete')){
    isFilterOpen.value = false;
  }
};


const activeFiltersArray = ref([]);

const activeItem = ref();
const selectedItems = ref(null);
const selectItem = (item) => {
  selectedItems.value = item;
  activeFiltersArray.value.push(item);
  emit("filterChanged", "status", activeFiltersArray.value);
}

const isItemSelected = (item) => {
  return activeFiltersArray.value.some(selected => selected.id === item.id);
};

const deleteItem = (index) => {
  activeFiltersArray.value.splice(index, 1);
    emit("filterChanged", "status", activeFiltersArray.value);
}

const inputBorderColor = ref('#CBD5E1');
const textInputColor = ref('#000000');
const filterValue = computed(() => {
    if (props.headers && props.headers.name) {
        inputBorderColor.value = userColor.value;
        textInputColor.value = userColor.value;
        return props.headers.name;
    } else {
        inputBorderColor.value = '#CBD5E1';
        textInputColor.value = '#000000';
        return '';
    }
});


var timer = 0;
const brand = ref("");
function handleKeyUp(event) {
    const brandFilter = {
        type: 'brand',
        value: event.target.value,
    };
    activeFiltersArray.value.push(brandFilter);
    emit("filterChanged", "brand", event.target.value);
}
function debouncedHandleKeyUp(event) {
    //selectItem(event.target.value);
    clearTimeout(timer);
    timer = setTimeout(() => {
        handleKeyUp(event);
      }, 500);
}

</script>

<template>
  <div class="filters" >
    <div class="filters__toggle item-icon" @click="toggleFilters">
        <img :src="configIcon" style="width:25px;"/>
    </div>
    <div>
    <div :class="{'filters__component': true, 'filters__component--open': isFilterOpen}">
      <div class="header-container">
            <div class="header" v-if="isFilterOpen">
              <div class="filter-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 37.461 37.926">
                  <g id="gestion" transform="translate(1.25 1.25)">
                    <g id="Grupo_697" data-name="Grupo 697" transform="translate(28.354)">
                      <line id="Línea_397" data-name="Línea 397" y1="22.755" transform="translate(3.303 12.67)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                      <line id="Línea_398" data-name="Línea 398" y1="5.353" transform="translate(3.303)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                      <circle id="Elipse_563" data-name="Elipse 563" cx="3.304" cy="3.304" r="3.304" transform="translate(0 5.692)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    </g>
                    <g id="Grupo_700" data-name="Grupo 700" transform="translate(13.72)">
                      <line id="Línea_399" data-name="Línea 399" y1="5.617" transform="translate(3.303 29.809)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                      <line id="Línea_400" data-name="Línea 400" y1="21.804" transform="translate(3.303)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                      <circle id="Elipse_564" data-name="Elipse 564" cx="3.304" cy="3.304" r="3.304" transform="translate(0 22.211)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    </g>
                    <g id="Grupo_699" data-name="Grupo 699">
                      <g id="Grupo_698" data-name="Grupo 698">
                        <line id="Línea_395" data-name="Línea 395" y1="14.537" transform="translate(3.303 20.889)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                        <line id="Línea_396" data-name="Línea 396" y1="13.585" transform="translate(3.303)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                        <circle id="Elipse_565" data-name="Elipse 565" cx="3.304" cy="3.304" r="3.304" transform="translate(0 13.952)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                      </g>
                    </g>
                  </g>
                </svg>

              </div>
              <div class="filters-title">{{ $t('field.filters') }}</div>
              <div class="close-icon" @click="closeFilters">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 27.784 25.383">
                  <g id="Grupo_6112" data-name="Grupo 6112" transform="translate(-295.883 -21.381)">
                    <line id="Línea_805" data-name="Línea 805" x2="23.547" y2="20.847" transform="translate(298 23.797)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-width="4"/>
                    <line id="Línea_807" data-name="Línea 807" y1="21.145" x2="23.067" transform="translate(298.481 23.5)" fill="none" :stroke="userColor" stroke-linecap="round" stroke-width="4"/>
                  </g>
                </svg>

            </div>
        </div>
      </div>
      <div class="filter-body" v-if="isFilterOpen">
        <div class="activeFilters">
          <h3>{{ activeFilters }}</h3>
          <ul class="activeList">
            <li v-for="(actives, index) in activeFiltersArray" :key="index">
              {{ actives.name || actives.value || actives}}
              <font-awesome-icon v-if="actives.name" class="delete" icon="times" @click="deleteItem(index)"/>
              <font-awesome-icon v-else class="delete" icon="times" @click="handleClear(index)"/>
            </li>
          </ul>
        </div>
        <div v-for="h in props.headers"
              :key="h.name"
              class="columnheader" 
              v-show="h.visible">
                <div v-if="h.name === 'status'" >
                  <div class="status">
                    <h3>{{ statusValue }}</h3>
                  </div>
                  <ul class="statusList">
                    <li v-for="status in h.filter.data" :key=status.id :class="{'selected' : isItemSelected(status)}" @click="!isItemSelected(status) && selectItem(status)">
                      {{ status.name }}
                    </li>
                  </ul>
                </div>
        </div>
        <div class="brand">
          <h3>{{ brandValue }}</h3>
          <CustomInput
                :class="{'selected' : selectedItem}"
                :value="filterValue.value"
                :placeholder="$t('field.search')"
                type="text"
                :name="props.name !== 'image' ? props.name : props.src"
                @keyup.enter="debouncedHandleKeyUp"
                >
            </CustomInput>
        </div>
        <div v-for="(h, index) in props.headers" :key="index" class="datecontainer">
          <div v-if="h.filter.type === 'date' && h.field === 'daterange' || 
                     h.filter.type === 'dateNoTime' && h.field === 'nextVisitDate'"> 
          <h3 v-if="h.field === 'daterange'" class="label">{{ $t('field.modified') }}</h3>
          <h3 v-if="h.field === 'nextVisitDate'" class="label">{{ $t('field.next_visit') }}</h3>
          <VueDatePicker 
                range
                v-model="date" 
                :six-weeks="true"
                :enable-time-picker="false" 
                :preset-dates="presetDates"
                :disabled-times="() => true"
                :format="dateformat"
                :year-range="[2000, 2050]"
                :hide-navigation="['month', 'year']"
                input-class-name="yauty-date-picker"
                placeholder="Seleccionar" 
                week-start="1"
                prevent-min-max-navigation
                auto-apply
                inline
                utc
                locale="es-ES"
                format="dd/MM - dd/MM"
                position="left"
                @update:modelValue="handleDateChangeClosed"
                @updateMonthYear="updateMonthYear"
                @internal-model-change="handleInternal"
                >
                <template #preset-date-range-button="{ label, value, presetDate }">
                    <span 
                        role="button"
                        :tabindex="0"
                        @click="presetDate(value)"
                        @keyup.enter.prevent="presetDate(value)"
                        @keyup.space.prevent="presetDate(value)">
                    {{ label }}
                    </span>
                </template>
                <template #month-year="{
                                month,
                                year,
                                months,
                                years,
                                updateMonthYear,
                                handleMonthYearChange
                            }">
                    <div class="calendar-custom-header">
                        <div class="icons" styles="with:32px;">
                            <font-awesome-icon icon="fa-solid fa-chevron-left" @click="minusMonth($event, updateMonthYear, month, year)" class="custom-icon"/>
                        </div>
                        <div class="custom-month-year-component">
                            <select 
                                class="select-input"
                                :value="month" 
                                @change="updateMonth($event, updateMonthYear, year)">
                                <option v-for="m in months" :key="m.value" :value="m.value" :class="{'selected':m.value == month}">{{ m.text }}</option>
                            </select>
                            <select 
                                class="select-input"
                                :value="year"
                                @change="updateYear($event, updateMonthYear, month)">
                                <option v-for="y in years" :key="y.value" :value="y.value" :class="{'selected':y.value == year}">{{ y.text }}</option>
                            </select>
                        </div>
                        <div class="icons" styles="with:32px;">
                            <font-awesome-icon icon="fa-solid fa-chevron-right" @click="addMonth($event, updateMonthYear, month, year)" class="custom-icon"/>
                        </div>
                    </div>
                </template>                
            </VueDatePicker>
        </div>
      </div>
      </div>
    </div>
  </div>
  </div>
</template>

<style lang="scss" >
::-webkit-scrollbar {display: none;}
.filters{
  display: none;
}
 @media (max-width: 576px) {
  .filters{
  display: block;
  position: relative;
    &__component{
        overflow: hidden;
        margin: 0;
        padding: 0;
        z-index: 1000;
        max-height: 0;
        overflow: hidden;
        width: 100%;
        transition: max-height 0.3s ease-in-out;
        margin-top: 7dvh;
        padding: 20px;
        position: fixed;
        right: 0;
        width: 97dvw;
        margin-left:1.5dvw;
        margin-right: 1.5dvw;
        border-radius: 0px 0px 24px 24px;
        &--open{
                overflow: hidden;
                overflow-y: scroll;
                z-index: 100;
                height: 92dvh;
                max-height: 92dvh;
                bottom: 0;
                border-radius: 24px 24px 0px 0px;
                background-color: white !important;
                box-shadow: 3px 0px 6px #00000029;
                .close-icon{
                    position: absolute;
                    z-index: 55;
                    right: 0px;
                    .icon{
                        height: 30px;
                        color: v-bind(userColor);
                    }
                }
                .header-container{
                    width: 97dvw;
                    margin-left:1.5dvw;
                    margin-right: 1.5dvw;
                    position: fixed;
                    background-color: white !important;
                    border-radius: 24px 24px 0px 0px;
                    z-index: 1;
                    left: 0px;
                    padding-top: 35px;
                    margin-top: -21px;
                    padding-bottom: 0px;
                  .header{
                    display: flex;
                    width: 86dvw;
                    left: 20px;
                    gap: 20px;
                    padding-bottom: 27.23px;
                    border-bottom: 1px solid rgba(172, 187, 186, 0.32);
                  }
                }
            }
          }

          .item-icon {
          background-color: v-bind(userColor);
          padding: 14px;
          border-radius: 50%;
          position: fixed;
          right: 40px;
          bottom: 85px;
          z-index: 55;
          }
      .config-icon{
        transform: rotate(90deg);
        height: 30px;
        color: v-bind(userColor);
      }
      .filters-title{
        font-family: 'CircularStd-Bold';
        color: black;
        font-size: 21px;
      }

      .filter-body{
        margin-top: 100px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        h3{
          font-size: 17px;
          font-family: 'CircularStd-Book';
          text-align: left;
          margin-bottom: 17px;
        }
      }
      .statusList{
        display: flex;
        overflow-x: scroll;
        gap: 20px;
        margin-left: -35px !important;
        li{
          list-style: none;
          text-wrap: nowrap;
          background-color: #f2f2f2;
          padding: 6px 17px;
          border-radius: 20px;
          font-size: 17px;
          text-transform: capitalize;
          font-family: 'CircularStd-Book';
        }
        
      .selected {
        background-color: v-bind(userColor) !important; 
        color: white;
      }
      }

      .activeList{
        display: flex;
        overflow-x: scroll;
        gap: 20px;
        margin-left: -35px !important;
        li{
          list-style: none;
          text-wrap: nowrap;
          background-color: v-bind(userColor);
          color: white;
          padding: 6px 17px;
          border-radius: 20px;
          font-size: 17px;
          text-transform: capitalize;
          font-family: 'CircularStd-Book';
        }
      }

      .delete{
            color: white;
            margin-left: 15px;
        }

      }

      .calendar-custom-header{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 10px;
              gap: 1.5rem;
              .custom-month-year-component{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap:5px;
                  select{
                      height: 37.6px;
                      width: 75px;
                      line-height: 1.25 !important;
                      border-radius: 0.24rem;
                      border: 0px solid #e2e8f0;
                      background-color: white !important;
                      padding-left: 0.5rem !important;
                      padding-right: 0 !important;
                      padding-top: 0.5rem !important;
                      padding-bottom: 0.5rem !important;
                      position: relative;
                      flex: 1 1 auto;
                      min-width: 0;
                      color: #707070;
                      font-family: 'CircularStd-Book';
                  }
                  select:focus {
                      outline: none;
                  }
              }
              .icons{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .custom-icon{
                      padding: 5px;
                      width: 20px;
                      height: 20px;
                      border-radius: 50%;
                      color: #CBD5E1;
                      font-size: 20px;
                      cursor: pointer;
                  }
                  .custom-icon:hover{
                      background-color: v-bind(userColor);
                      color: white;
                  }
              }
          }
          .datecontainer{
            .label{
              margin-top: 25px;
            }     
      }
      .calendar-custom-header{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 10px;
              gap: 1.5rem;
              .custom-month-year-component{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap:5px;
                  select{
                      height: 37.6px;
                      width: 100px;
                      line-height: 1.25 !important;
                      border-radius: 0.24rem;
                      border: 0px solid #e2e8f0;
                      background-color: transparent !important;
                      padding-left: 0.5rem !important;
                      padding-right: 0 !important;
                      padding-top: 0.5rem !important;
                      padding-bottom: 0.5rem !important;
                      position: relative;
                      flex: 1 1 auto;
                      min-width: 0;
                      color: white;
                      font-weight: bold;
                      font-family: 'CircularStd-Book';
                      font-size: 20px;
                  }
                  select:focus {
                      outline: none;
                  }
              }
              .icons{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .custom-icon{
                      padding: 5px;
                      width: 20px;
                      height: 20px;
                      border-radius: 50%;
                      color: #CBD5E1;
                      font-size: 20px;
                      cursor: pointer;
                  }
                  .custom-icon:hover{
                      background-color: v-bind(selectedColor);
                      color: white;
                  }
              }
          }
          .datecontainer{
            .label{
              margin-top: 25px;
              font-size: 17px;
              font-family: 'CircularStd-Book';
            }
     }
        .dp__range_end, .dp__range_start, .dp__active_date {
        background: v-bind(selectedColor);
        border-radius: 100%;
        color: white;
    }
    .dp__range_between {
        background-color: v-bind(selectedColorHover);
        border: none;
        color: white;
    }
    .dp__today {
        border-radius: 100%;
        border: 1px solid v-bind(selectedColor);
    }
    .dp__menu_content_wrapper {
      background-image: linear-gradient(to right, v-bind(userTertiaryColor), v-bind(userColor)) !important;
      border-radius: 20px;
      max-width: 100%;
      margin: auto;
    }
    .dp__pointer {
        color: white;
        cursor: pointer;
    }
    .dp__calendar {
    margin: 0px 7px;
    }
    .dp__calendar_header {
    margin: 10px 10px 0px 10px;
    }
    .dp__month_year_row {
        margin-top: 15px;
    }
    .dp__calendar_header_item {
        text-transform: uppercase;
        font-weight: bold;
        text-align: left;
       color: #c0c4cc;
    }
        .dp__calendar_header_separator {
        display: none;
    }
    .dp__btn {
        background: none;
        color: white;
        font-weight: bold;
    }
    .dp__cell_offset {
            color: #c0c4cc !important;
        }
        .dp__relative {
            position: relative;
            border: none;
        }
        .dp--preset-range:hover{
            background-color: v-bind(selectedColor) !important;
            color: white;
        }
        .dp--preset-range {
            font-weight: 400 !important;
            margin-bottom: 10px;
            margin-top: -5px;
        }
     }
</style>

